<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-primary shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-md-3">
                <card
                  class="border-0 d-flex card-ppj"
                  hover
                  shadow
                  body-classes="text-center align-items-center d-flex justify-content-center"
                >
                  <object
                    data="/img/svg/1-Peneranagan Jalan.svg"
                    type="image/svg+xml"
                    class="text-white card-pajak"
                  ></object>
                  <h6
                    class="text-white text-uppercase title-inside-card"
                    style="margin-top: 7px"
                  >PAJAK PENERANGAN JALAN</h6>
                </card>
              </div>
              <div class="col-lg-8">
                <h1 class="display-3 text-white">
                  Pelayanan Pajak Penerangan Jalan
                  <span>Kabupaten Ketapang</span>
                </h1>
                <p class="description mt-3 text-white">
                  Pajak Penerangan Jalan atau PPJ atau masyarakat menyebutnya
                  sebagai Pajak Listrik atau Pajak PJU dikenakan kepada
                  Pelanggan Listrik, yaitu adalah orang dan/atau badan yang
                  menjadi pemilik/penyewa/penghuni bangunan rumah dan bangunan
                  lainnya yang menggunakan listrik dari Perusahaan Listrik
                  Negara (PLN) atau bukan PLN.
                </p>

                <p class="description mt-3 text-white">
                  Objek Pajak Penerangan Jalan adalah penggunaan tenaga listrik,
                  baik yang dihasilkan sendiri maupun yang diperoleh dari sumber
                  lain. Listrik yang dihasilkan sendiri sebagaimana dimaksud
                  pada ayat meliputi seluruh pembangkit listrik.
                </p>

                <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    class="mb-3 mb-sm-0"
                    type="info"
                    textColor="white"
                    icon="fa fa-arrow-left"
                    @click="goback()"
                  >Kembali</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <br />
    <br />
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">E-SPTPD</h6>
                  <p class="description mt-3">Pendataan SPTPD Pajak Penerangan Jalan secara Online.
                    <br />
                    <br />
                    <br /></p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="success"
                    class="mt-4"
                    @click="goSptpdPajak()"
                  >E-SPTPD</base-button>
                </card>
              </div>
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-cog" type="danger" rounded class="mb-4"></icon>
                  <h6 class="text-danger text-uppercase">Cetak SSPD</h6>
                  <p class="description mt-3">Cetak SSPD Pajak Penerangan Jalan.
                    <br />
                    <br />
                    <br /></p>
                  <br />
                  <base-button
                    tag="a"
                    textColor="white"
                    type="warning"
                    class="mt-4"
                    @click="cetakSSPD()"
                  >Cetak</base-button>
                </card>
              </div>
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-print" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">Informasi Pajak Penerangan Jalan</h6>
                  <p class="description mt-3">
                    Melihat Informasi Pajak Penerangan Jalan berdasarkan NPWPD
                    pemilik usaha.
                    <br />
                    <br />
                  </p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="success"
                    class="mt-4"
                    @click="goInformasiPajak()"
                  >Informasi Pajak</base-button>
                </card>
              </div>
              <div class="col-md-3">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-cog" type="warning" rounded class="mb-4"></icon>
                  <h6 class="text-warning text-uppercase">Peraturan Pajak Penerangan Jalan</h6>
                  <p class="description mt-3">
                    Dasar Hukum pemungutan Pajak Penerangan Jalan yang termuat
                    dalam undang-undang.
                  </p>
                  <base-button
                    tag="a"
                    textColor="white"
                    type="warning"
                    class="mt-4"
                    @click="goDasarHukum()"
                  >Dasar Hukum</base-button>
                </card>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />
        <div class="row">
          <div class="col-md-12">
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
      </div>
    </section>
    <modal-informasi-pajak
      ref="modal-informasi-pajak"
      title="Pencarian Informasi Pajak Penerangan Jalan"
      code="1109"
      url="/api/v1/pajak-daerah"
    ></modal-informasi-pajak>

    <modal :show.sync="dasar_hukum" footerClasses="text-right" :largeModal="true">
      <h6
        slot="header"
        class="modal-title text-success font-weight-bold"
        id="modal-title-default"
      >Dasar Hukum Pajak Penerangan Jalan</h6>
      <div class="d-block">
        <div class="elementor-widget-container">
          <h2>Pajak Penerangan Jalan</h2>

          <p>
            Penerangan jalan termasuk ke dalam pajak daerah. Lampu-lampu yang
            berjajar di sepanjang jalan, menerangi kala malam hari, ternyata
            turut dikenai pajak. Lalu, berapa besaran tarifnya dan bagaimana
            penghitungannya? Simak selengkapnya di artikel ini!
          </p>

          <h2>Objek dan Subjek Pajak</h2>

          <p>
            Pajak penerangan jalan adalah pajak atas penggunaan tenaga listrik,
            baik yang dihasilkan sendiri maupun diperoleh dari sumber lain. Pada
            konteks ini, sumber lain tersebut adalah tenaga listrik dari PLN
            dan/atau bukan PLN.&nbsp;
          </p>

          <p>
            Objek pajak penerangan jalan ini adalah penggunaan tenaga listrik
            untuk lampu-lampu tersebut. Baik yang dihasilkan sendiri maupun
            diperoleh dari sumber lain. Listrik yang dihasilkan sendiri di sini
            adalah pembangkit listrik.
          </p>

          <p>
            Namun, tidak semua penggunaan listrik termasuk dalam objek pajak
            ini. Penggunaan tenaga listrik oleh instansi pemerintah dan
            pemerintah daerah, penggunaan tenaga listrik pada tempat-tempat yang
            digunakan oleh kedutaan atau perwakilan asing dengan azas timbal
            balik, serta penggunaan tenaga listrik yang dihasilkan sendiri
            dengan kapasitas di bawah 200 kvA (200 kilovolt ampere) dan tidak
            membutuhkan izin dari instansi teknis terkait, tidak termasuk dalam
            objek pajak ini.
          </p>

          <p>
            Subjek pajaknya sendiri adalah orang pribadi atau badan yang dapat
            menggunakan tenaga listrik. Jika listrik berasal dari sumber lain
            (PLN), wajib pajaknya adalah pihak penyedia tenaga listrik.&nbsp;
          </p>

          <h2>Dasar Pengenaan Pajak</h2>

          <p>
            Lalu, bagaimana dasar pengenaan pajaknya (DPP)? Karena objek
            pajaknya adalah penggunaan tenaga listrik, maka DPP-nya adalah nilai
            jual tenaga listrik. Penetapannya:
          </p>

          <ul>
            <li>
              Jika tenaga listrik berasal dari PLN dengan pembayaran, nilai
              jualnya adalah jumlah tagihan beban tetap ditambah biaya pemakaian
              kWh atau variabel yang ditagihkan dalam rekening listrik.
            </li>
            <li>
              Jika tenaga listrik bukan PLN dan tidak dipungut pembayaran, nilai
              jualnya dihitung berdasarkan kapasitas tersedia, tingkat
              penggunaan listrik, jangka waktu pemakaian listrik, dan harga
              satuan listrik yang berlaku di wilayah daerah tersebut.
            </li>
            <li>
              Khusus untuk kegiatan industri, pertambangan minyak bumi dan gas
              alam, nilai jual tenaga listrik ditetapkan sebesar 30%.
            </li>
          </ul>

          <h2>Tarif Pajak Penerangan Jalan</h2>

          <p>
            Karena disetorkan ke pemerintah daerah, tarif pajak ini dapat
            berbeda-beda tergantung peraturan daerah yang berlaku. Namun, tarif
            paling tinggi adalah 10%. Ada beberapa tarif
            pengenaan pajak yang berlaku:
          </p>

          <ul>
            <li>
              Tarif pajak dengan listrik&nbsp; disediakan oleh PLN atau bukan
              PLN yang digunakan oleh industri, pertambangan minyak bumi dan gas
              alam adalah 3%.
            </li>
            <li>
              Tarif pajak dengan sumber listrik dari PLN atau bukan PLN dan
              digunakan selain industri, pertambangan minyak bumi dan gas alam
              adalah 2,4%.
            </li>
            <li>
              Tarif pajak dengan penggunaan listrik dihasilkan sendiri adalah
              1,5%.
            </li>
          </ul>

          <p>
            Rumus dari penghitungan pajak penerangan jalan adalah: Tarif pajak x
            Nilai Jual Tenaga Listrik
          </p>

          <p>
            <strong>Contoh Penghitungan Pajak Penerangan Jalan</strong>
          </p>

          <p>
            Sebuah perusahaan bisnis membayar tagihan listrik PLN di luar pajak
            pada bulan Januari 2020 sebesar Rp10,800,000. Daya yang dimiliki
            adalah 1.300 VA.
          </p>

          <p>Maka, penghitungan pajak penerangan jalannya adalah:</p>

          <blockquote class="wp-block-quote">
            <p>Rumus: Tarif pajak x Nilai Jual Tenaga Listrik</p>
            <p>Tarif pajak yang berlaku: 4%</p>
            <p>Nilai Jual Tenaga Listrik (DPP): Rp10,800,000</p>
            <p>Besaran pajak yang harus dibayar: 4% x Rp10,800,000= Rp432,000</p>
          </blockquote>

          <p>
            Setelah mendapatkan besaran pajak terutangnya, wajib pajak harus
            menyetorkannya ke pemerintah daerah setiap bulan.&nbsp;
          </p>

          <h2>Kesimpulan</h2>

          <p>
            Penerangan jalan merupakan salah satu pajak daerah yang harus
            dibayar oleh orang atau badan yang menyediakan atau menggunakan
            tenaga listrik tersebut. Dasar pengenaan pajak ini adalah nilai jual
            tenaga listrik, dan besaran tarif ditetapkan berdasarkan peraturan
            daerah yang berlaku. Setelah mendapatkan besaran pajaknya, setorkan
            ke pemerintah daerah setiap bulannya.
          </p>

          <p>
            Jika Anda memiliki pajak penerangan jalan maupun pajak daerah
            lainnya, jangan lupa untuk memenuhi kewajiban perpajakan Anda kepada
            pemerintah daerah. Jika memiliki pajak yang harus dilaporkan ke
            pusat atau negara, gunakan
            <a
              href="/ebilling-bayar-pajak-online"
              target="_blank"
              rel="noreferrer noopener"
              aria-label=" (opens in a new tab)"
            >OnlinePajak</a>untuk mempermudah urusan hitung, setor, lapor pajak bisnis Anda.
            <br />
          </p>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import ModalInformasiPajak from "../GlobalPage/InformasiPajak";
import { Chart } from "highcharts-vue";
import axios from "axios";
import Modal from "@/components/Modal.vue";
export default {
  name: "ppj",
  components: {
    ModalInformasiPajak,
    highcharts: Chart,
    Modal,
  },
  data() {
    return {
      items: [],
      dasar_hukum: false,
    };
  },
  computed: {
    checkAkses() {
      if (this.$store.state.auth.status.loggedIn)
        if (this.$store.state.auth.user.is_wajib_pajak)
          return this.$store.state.auth.user.registrations.find((item) => item.business_id == 5)
        else
          return this.$store.state.auth.user.business_id == 5;
      return false;
    },
    chartOptions() {
      return {
        chart: {
          type: "column",
        },
        title: {
          text: "Realisasi Pajak Penerangan Jalan berdasarkan Tahun",
        },
        subtitle: {
          text: "Data tahun yang di ambil adalah data 10 tahun kebelakang.",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah Realisasi",
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.y:.2f}",
            },
          },
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
        },

        series: [
          {
            name: "Tahun",
            colorByPoint: true,
            data: this.items,
          },
        ],
      };
    },
  },
  created() {
    this.getRealisasi();
  },
  methods: {
    async getRealisasi() {
      try {
        this.isBusy = true;
        let { data } = await axios.get("/api/v1/realisasi/ppj");

        var items = [];
        for (const [key, value] of Object.entries(data)) {
          this.items.push({
            name: value.tahun_realisasi,
            y: parseFloat(value.realisasi),
          });
        }
      } catch (error) {
        // console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    goInformasiPajak() {
      this.$refs["modal-informasi-pajak"].showModal();
    },
    goWajibPajak() {
      this.$refs["modal-wajib-pajak"].showModal();
    },
    goDasarHukum() {
      this.dasar_hukum = true;
    },
    goback() {
      this.$router.go(-1);
    },
    goWajibPajakPendaftaran() {
      this.$router.push("/pajak-penerangan-jalan/daftar");
    },
    goSptpdPajak() {
      this.$router.push("/pajak-penerangan-jalan/e-sptpd");
    },
    cetakSSPD() {
      this.$router.push("/pajak-penerangan-jalan/pembayaran");
    },
  },
};
</script>
<style lang="scss" scoped>
.section-shaped .shape.shape-skew + .shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card-ppj {
  height: 100%;
}
</style>